module.exports = window.fetch = require('unfetch');
